import { ControlsToggleExtraContent, LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

export const extraContent: ControlsToggleExtraContent = [
  {
    type: "audioButton",
    options: {
      theme: "primary",
      url: `${config.ASSETS_URL}/02/10/principle/pressure-cooker.wav`,
      text: "play sound",
      shape: "round",
      icon: "cis-volume-high",
    },
  },
];

export const components: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 1,
        rows: 2,
        rowsSize: [5, 1],
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/10/principle/chart-2-3.svg`,
                  },
                },
                styles: {
                  width: "75%",
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "badge",
                  options: {
                    size: "large",
                    items: ["<b>S = 2.83 acum</b>"],
                  },
                },
              },
            },
          ],
        ],
      },
    },
  },
];
